/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Данные организации заказчика (состав полей зависит от organizationType)
 * @export
 * @interface GetDataFirstStage200ResponseDataCustomerOrganizationData
 */
export interface GetDataFirstStage200ResponseDataCustomerOrganizationData {
  /**
   * Тип организации (дублируется внутри объекта)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  organizationType?: string | null
  /**
   * ИНН (кроме FOREIGN_COMPANY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  inn?: string | null
  /**
   * СНИЛС (только INDIVIDUAL_ENTITY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  snils?: string | null
  /**
   * Серия и номер паспорта (только INDIVIDUAL_ENTITY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  passportSeriesNumber?: string | null
  /**
   * Наименование с кратким ОПФ
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  name?: string | null
  /**
   * Адрес с индексом, городом, улицей и квартирой
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  address?: string | null
  /**
   * Адрес для корреспонденции
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  addressCorrespondent?: string | null
  /**
   * Транслитерированное наименование (только FOREIGN_COMPANY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  nameTransliterate?: string | null
  /**
   * Регистрационный номер (только FOREIGN_COMPANY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  regNumber?: string | null
  /**
   * Налоговый номер (только FOREIGN_COMPANY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  taxNumber?: string | null
  /**
   * Код страны из словаря (только FOREIGN_COMPANY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  countryCode?: string | null
  /**
   * Транслитерированный адрес (только FOREIGN_COMPANY)
   * @type {string}
   * @memberof GetDataFirstStage200ResponseDataCustomerOrganizationData
   */
  addressTransliterate?: string | null
}

/**
 * Check if a given object implements the GetDataFirstStage200ResponseDataCustomerOrganizationData interface.
 */
export function instanceOfGetDataFirstStage200ResponseDataCustomerOrganizationData(
  value: object
): value is GetDataFirstStage200ResponseDataCustomerOrganizationData {
  return true
}

export function GetDataFirstStage200ResponseDataCustomerOrganizationDataFromJSON(
  json: any
): GetDataFirstStage200ResponseDataCustomerOrganizationData {
  return GetDataFirstStage200ResponseDataCustomerOrganizationDataFromJSONTyped(
    json,
    false
  )
}

export function GetDataFirstStage200ResponseDataCustomerOrganizationDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataFirstStage200ResponseDataCustomerOrganizationData {
  if (json == null) {
    return json
  }
  return {
    organizationType:
      json['organizationType'] == null ? undefined : json['organizationType'],
    inn: json['inn'] == null ? undefined : json['inn'],
    snils: json['snils'] == null ? undefined : json['snils'],
    passportSeriesNumber:
      json['passportSeriesNumber'] == null
        ? undefined
        : json['passportSeriesNumber'],
    name: json['name'] == null ? undefined : json['name'],
    address: json['address'] == null ? undefined : json['address'],
    addressCorrespondent:
      json['addressCorrespondent'] == null
        ? undefined
        : json['addressCorrespondent'],
    nameTransliterate:
      json['nameTransliterate'] == null ? undefined : json['nameTransliterate'],
    regNumber: json['regNumber'] == null ? undefined : json['regNumber'],
    taxNumber: json['taxNumber'] == null ? undefined : json['taxNumber'],
    countryCode: json['countryCode'] == null ? undefined : json['countryCode'],
    addressTransliterate:
      json['addressTransliterate'] == null
        ? undefined
        : json['addressTransliterate'],
  }
}

export function GetDataFirstStage200ResponseDataCustomerOrganizationDataToJSON(
  value?: GetDataFirstStage200ResponseDataCustomerOrganizationData | null
): any {
  if (value == null) {
    return value
  }
  return {
    organizationType: value['organizationType'],
    inn: value['inn'],
    snils: value['snils'],
    passportSeriesNumber: value['passportSeriesNumber'],
    name: value['name'],
    address: value['address'],
    addressCorrespondent: value['addressCorrespondent'],
    nameTransliterate: value['nameTransliterate'],
    regNumber: value['regNumber'],
    taxNumber: value['taxNumber'],
    countryCode: value['countryCode'],
    addressTransliterate: value['addressTransliterate'],
  }
}
